export enum DeviceConfigurationUpdateResponse {
  CONF_ERR_INCORRECT_CHECKSUM = "CONF_ERR_INCORRECT_CHECKSUM",
  CONF_ERR_INCORRECT_VERSION = "CONF_ERR_INCORRECT_VERSION",
  CONF_ERR_INCORRECT_LENGTH = "CONF_ERR_INCORRECT_LENGTH",
  CONF_ERR_UNKNOWN = "CONF_ERR_UNKNOWN",
  CONF_NO_ERR = "CONF_NO_ERR",
  CUSTOM_ERROR_INVALID_JSON = "INVALID JSON CONFIGURATION"
}
